<mat-form-field appearance="outline" class="">
    <mat-chip-list #chipList aria-label="Product Line Selection">
        <mat-chip *ngFor="let prod of prods" (removed)="remove(prod)">
            {{prod.line_description}}
            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip>
        <input placeholder="Add a product line... (* to add all results)" #prodInput [formControl]="prodCtrl" [matAutocomplete]="auto" [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="add($event)">
    </mat-chip-list>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
        <mat-option *ngFor="let prod of filteredProds" [value]="prod.line_field">
            {{prod.line_description}}
        </mat-option>
    </mat-autocomplete>
    <button matSuffix mat-raised-button color="primary"  (click)="addWildCard()">Add multiple</button>
</mat-form-field>

<button mat-raised-button (click)="clearall()">Reset</button>